import { memo, useCallback } from 'react';
import { Button, InfoImage } from '@bonanza-social/moonlight';
import { OnfidoEntryBottomSheetProps } from './OnfidoEntryBottomSheet.types';
import useOnfido from '../../hooks/useOnfido';

function OnfidoEntryBottomSheet({ close }: OnfidoEntryBottomSheetProps) {
  const onfido = useOnfido();

  const onPress = useCallback(() => {
    onfido.start({
      onInit: close,
    });
  }, [onfido, close]);

  return (
    <InfoImage
      titleKey="importantInformation"
      titleNS="onboarding"
      descriptionKey="healthCardsInfo"
      descriptionNS="onboarding"
      centerContent
    >
      <Button
        locKey="okay"
        locNS="common"
        size="large"
        width="100%"
        loading={onfido.initializing}
        onPress={onPress}
      />
    </InfoImage>
  );
}

export default memo(OnfidoEntryBottomSheet);
